module.exports = __WEBPACK_EXTERNAL_MODULE_6__;


//////////////////
// WEBPACK FOOTER
// external {"root":"whatwg-fetch","commonjs2":"whatwg-fetch","commonjs":"whatwg-fetch","amd":"whatwg-fetch"}
// module id = 6
// module chunks = 0